import { render } from "./HostTaxInvoices.vue?vue&type=template&id=4d2fb672"
import script from "./HostTaxInvoices.vue?vue&type=script&lang=js"
export * from "./HostTaxInvoices.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__